import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaChip from './VaChip.vue'

export const VaChip = withConfigTransport(_VaChip)
